// extracted by mini-css-extract-plugin
module.exports = {"font_extra_bold":"800","root":"compare_button__root__F49cv","rootInactive":"compare_button__rootInactive__2pBYc"};